import { useCallback, useEffect, useState } from 'react'
import Project from '../../../common/project'
import _data from '../../../common/utils/_data'

export function useLawAreas() {
  const [lawAreas, setLawAreas] = useState([])

  const fetchAreas = useCallback(async () => {
    try {
      const areas = await _data.get(
        `${Project.liveApi}law-categorisation/areas`,
      )
      setLawAreas(areas.results || [])
    } catch (error) {
      console.error('Error fetching law areas:', error)
    }
  }, [])

  useEffect(() => {
    fetchAreas()
  }, [fetchAreas])

  return lawAreas
}

export function useLawSubAreas() {
  const [subAreas, setLawSubAreas] = useState([])

  const fetchSubAreas = useCallback(async () => {
    try {
      const subAreas = await _data.get(
        `${Project.liveApi}law-categorisation/sub-areas`,
      )
      setLawSubAreas(subAreas.results || [])
    } catch (error) {
      console.error('Error fetching law sub-areas:', error)
    }
  }, [])

  useEffect(() => {
    fetchSubAreas()
  }, [fetchSubAreas])

  return subAreas
}

export function useAnalyticsCities() {
  const [cities, setCities] = useState([])

  const fetchCities = useCallback(async () => {
    try {
      const cities = await _data.get(`${Project.liveApi}analytics/cities`)
      setCities(cities || [])
    } catch (error) {
      console.error('Error fetching cities:', error)
    }
  }, [])

  useEffect(() => {
    fetchCities()
  }, [fetchCities])

  return cities
}

export function useLegalServices() {
  const [legalServices, setLegalServices] = useState([])

  const fetchLegalServices = useCallback(async () => {
    try {
      const services = await _data.get(
        `${Project.liveApi}legal-services/get-services/`,
      )
      setLegalServices(services || [])
    } catch (error) {
      console.error('Error fetching legal services:', error)
    }
  }, [])

  useEffect(() => {
    fetchLegalServices()
  }, [fetchLegalServices])

  return legalServices
}
